module.exports = __webpack_public_path__ + "img/img9.a99ede3d.svg";